// import CommonHeader from "../../components/Onboarding/v2/CommonHeader";
import CommonHeader from "../../components/Onboarding/CommonHeader";
import React from "react";
import { useNavigate } from "react-router-dom";
const DeletedWantAd = () => {
  const navigate = useNavigate();
  return (
    <div className="deletewantadpage">
      <div className="deletewantadpage__header mw-1168 my-0 mx-auto">
        <CommonHeader />
      </div>
      <div className="deleteWantAdWrapper">
        <h3 className="deletedWantAdHead">
          This want-listing has been removed.
        </h3>
        <p className="text-center deleteWantAdSubHead ">
          The user may have already found something!
          <br /> Sign in/up to view similar want-listings in your area.
        </p>
        <button className="btn-primary w-100" onClick={() => navigate("/home")}>
          Go back to feed
        </button>
      </div>
    </div>
  );
};

export default DeletedWantAd;
